import yup from 'yup';

import { UpdateAccount } from '../../mutations/UpdateAccount';

const ERROR_REQUIRED = 'This field is required';
const ERROR_SHORT_PASS = 'Minimum 8 characters';
const ERROR_MATCH_PASS = 'Passwords do not match';

export const formikConfig = {
  enableReinitialize: true,
  mapPropsToValues: ({ currentUser }) => {
    const initialValues = {
      name: '',
      phoneNumber: '',
      surname: '',
      currentPassword: '',
      password: '',
      passwordConfirmation: ''
    };
    if (currentUser) {
      return {
        ...initialValues,
        name: (currentUser && currentUser.name) || '',
        phoneNumber: (currentUser && currentUser.phoneNumber) || '',
        surname: (currentUser && currentUser.surname) || '',
        currentPassword: (currentUser && currentUser.currentPassword) || ''
      };
    }
    return initialValues;
  },
  validationSchema: () =>
    yup.object().shape({
      name: yup.string().required(ERROR_REQUIRED),
      surname: yup.string().required(ERROR_REQUIRED),
      phoneNumber: yup.string().required(ERROR_REQUIRED),
      currentPassword: yup.string().required(ERROR_REQUIRED),
      password: yup.string().min(8, ERROR_SHORT_PASS),
      passwordConfirmation: yup
        .string()
        .test('password-match', ERROR_MATCH_PASS, function(value) {
          const { password } = this.parent;
          return password === value;
        })
    }),
  handleSubmit: (values, { props, setErrors, setSubmitting, setStatus }) => {
    const input = { user: { ...values } };
    props.client
      .mutate({
        mutation: UpdateAccount,
        variables: {
          input: input
        }
      })
      .then(({ data }) => {
        setErrors({});
        setSubmitting(false);
        setStatus({ redirect: true });
        props.actions.showMessage({
          header: 'Settings changed',
          text: 'Your account settings has been successfully changed!',
          props: { success: true },
          duration: 2000
        });
      })
      .catch(error => {
        setErrors({ serverError: error });
        setSubmitting(false);
        window.scrollTo(0, 0);
      });
  }
};



// WEBPACK FOOTER //
// ./src/component/Settings/formikConfig.js